// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"3fbff9a4","488":"2ddf52a1","523":"467d367f","572":"9975a45f"}[chunkId] + ".chunk.js";
};